import classes from './Closebutton.module.css';

const Closebutton = (props) => {
    return (
        <button className={classes.close} onClick={props.onClick}>X</button>
    ) 


}

export default Closebutton;

